import { render, staticRenderFns } from "./CreateTeacherCertificateDialog.vue?vue&type=template&id=73b65d06&scoped=true&"
import script from "./CreateTeacherCertificateDialog.vue?vue&type=script&lang=js&"
export * from "./CreateTeacherCertificateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b65d06",
  null
  
)

export default component.exports